import theme from 'tailwindcss/defaultTheme.js';

const config = {
  darkMode: 'class',
  theme,
};

export default config;
